import { css } from 'lit';
export const notificationBarStyles = css `
    .hlx-notification-bar {
        position: relative;
        z-index: 9999999;
    }

    .hlx-timer {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: var(--hlx-spacing-2xs);
        background: var(--hlx-color-neutral-80);
    }

    .hlx-timer-animation {
        transform-origin: left top;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-name: time-animation;
    }

    .hlx-timer-paused {
        animation-play-state: paused;
    }

    .hlx-timer-hidden {
        display: none;
    }

    @keyframes time-animation {
        from {
            transform: scaleX(0);
        }
        to {
            transform: scaleX(1);
        }
    }

    @media (prefers-reduced-motion) {
        .hlx-timer-animation {
            animation-timing-function: steps(6);
        }
    }
`;
//# sourceMappingURL=notification-bar.styles.js.map